import styled from 'styled-components'

import { Color } from 'root-constants'

const BaseText = styled.p`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: ${Color.INK_DARKEST};
`

export const SelectGenderBlessV3 = {
  Container: styled.div`
    max-width: 375px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 16px 24px 0;
    margin: 0 auto;
  `,
  Title: styled.h1`
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;

    font-weight: 700;
    text-align: center;
    color: ${Color.INK_DARKEST};
  `,
  Subtitle: styled(BaseText)`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_LIGHTER};
  `,
  Note: styled(BaseText)`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_LIGHTER};

    margin-bottom: 16px;
  `,
  CardsContainer: styled.div`
    width: 100%;
    height: 295px;
    display: flex;
    flex-direction: row;
    gap: 12px;

    margin: 16px 0;
  `,
  Terms: styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    margin-top: 40px;

    a {
      color: ${Color.INK_DARKEST};
      text-decoration: underline;
      padding-top: 8px;
      display: inline-block;
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
    }
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 24px 0;
  `,
  Separator: styled.span`
    display: inline-flex;
    height: 16px;
    width: 1px;
    background-color: ${Color.SKY_DARK};
    margin: 0 8px;
    vertical-align: middle;
  `,
}
